import { TViewModifierGroupAction, ViewModifierGroupActionTypes } from './viewModifierGroupActions';
import { IViewModifierGroupState } from './viewModifierGroupContext';

export const viewModifierGroupReducer = (
	state: IViewModifierGroupState,
	action: TViewModifierGroupAction,
): IViewModifierGroupState => {
	switch (action.type) {
		case ViewModifierGroupActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case ViewModifierGroupActionTypes.REFETCH_REST_PROPS_DATA:
			return {
				...state,
				needRefetchRestPropsData: action.payload.needRefetchRestPropsData,
			};
		case ViewModifierGroupActionTypes.SET_MODIFIER_GROUP_FULL_INFO:
			return {
				...state,
				modifierGroupFullInfo: action.payload.modifierGroupFullInfo,
				accessibleRestaurants: action.payload.accessibleRestaurants,
			};
		case ViewModifierGroupActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS:
			return {
				...state,
				restaurantIdForRestaurantProps: action.payload.restaurantIdForRestaurantProps,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewModifierGroupActionTypes.SET_RESTAURANT_PROPS:
			return {
				...state,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewModifierGroupActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case ViewModifierGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
